<template>
  <AppSpinner v-if="loading">Loading Assignment...</AppSpinner>
  <router-view v-else :key="$route.fullPath"></router-view>
</template>

<script>
import AppSpinner from '@/views/components/AppSpinner.vue'

export default {
  name: 'StartAssignmentRoot',
  components: {
    AppSpinner,
  },
  data() {
    return {
      loading: true,
      error: null,
    }
  },
  async mounted() {
    try {
      // Load data here.
    } catch (err) {
      this.error = err
    } finally {
      this.loading = false
    }
  },
}
</script>
<style lang="scss" scoped></style>
